'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {IonSpinner} from '../../../_libs/reactionic/src/components/ionSpinner';
import {ButtonState} from '../../../core-utilities/enums/ButtonState';
import {I18nMessage} from '../../I18nMessage';
import {Button} from '../Button';


export function StatefulButtonView(props) {
  return (
    <Button
      className={classNames(
        "StatefulButton",
        props.className,
        props.buttonClassName,
        {
          StatefulButton_flipped: props.mode !== ButtonState.START,
        })}
      activeClassName="StatefulButton_active"
      disabledClassName="StatefulButton_disabled"
      disabled={props.disabled}
      useClickBlock={true}
      onClick={props.onClick}
    >
      <div className="StatefulButton__face">
        <div className={classNames("StatefulButton__front", props.frontClassName, props.startClassName)}>
          <div className="StatefulButton__content">
            {props.startLabel}
          </div>
        </div>
        <div className={classNames("StatefulButton__back", props.backClassName, getClassForState(props))}>
          <div className="StatefulButton__content">
            <span
              className={classNames({
                StatefulButton__label_working: props.mode === ButtonState.WORKING,
              })}
            >
              {getLabelForState(props)}
            </span>
            {props.mode !== ButtonState.WORKING ? null : (
              <IonSpinner
                className={props.workingIconClassName}
                icon="crescent"
              />
            )}
          </div>
        </div>
      </div>
    </Button>
  );
}

function getClassForState(props) {
  switch (props.mode) {
    case ButtonState.WORKING:
      return props.workingClassName;
    case ButtonState.CONFIRM:
      return props.confirmClassName;
    case ButtonState.SUCCESS:
      return props.successClassName;
    case ButtonState.ERROR:
      return props.failureClassName;
    default:
      return props.useConfirmation ? props.confirmClassName : props.workingClassName;
  }
}

function getLabelForState(props) {
  switch (props.mode) {
    case ButtonState.WORKING:
      return props.workingLabel;
    case ButtonState.CONFIRM:
      return props.confirmLabel;
    case ButtonState.SUCCESS:
      return props.successLabel;
    case ButtonState.ERROR:
      return props.errorLabel;
    default:
      return props.useConfirmation ? props.confirmLabel : props.workingLabel;
  }
}

export const labelType = T.node;

StatefulButtonView.propTypes = {
  className: T.string,
  /** @type {String} Use to overwrite default button styling */
  buttonClassName: T.string,
  /** @type {String} Use to overwrite default back styling */
  frontClassName: T.string,
  backClassName: T.string,
  startClassName: T.string.isRequired,
  confirmClassName: T.string.isRequired,
  workingClassName: T.string.isRequired,
  workingIconClassName: T.string,
  successClassName: T.string.isRequired,
  failureClassName: T.string.isRequired,
  useConfirmation: T.bool,
  mode: T.number.isRequired,
  startLabel: labelType,
  confirmLabel: labelType,
  successLabel: labelType,
  errorLabel: labelType,
  workingLabel: labelType,
};

StatefulButtonView.defaultProps = {
  buttonClassName: 'StatefulButton_style',
  frontClassName: 'StatefulButton__front_style',
  backClassName: 'StatefulButton__back_style',
  startClassName: 'StatefulButton_start',
  confirmClassName: 'StatefulButton_confirm',
  workingClassName: 'StatefulButton_working',
  successClassName: 'StatefulButton_success',
  failureClassName: 'StatefulButton_failure',
  startLabel: <I18nMessage message="default.okay.label" />,
  confirmLabel: <I18nMessage message="default.confirm.label" />,
  workingLabel: <I18nMessage message="default.working.label" />,
  successLabel: <I18nMessage message="default.success.label" />,
  errorLabel: <I18nMessage message="default.error.label" />,
};



// WEBPACK FOOTER //
// ./src/js/components/buttons/StatefulButton/StatefulButtonView.js